import React from "react";
import styled from "styled-components";
import { Container } from "../Components/Atoms";
import config from "../Config";
import GlobalStyle from "../globalStyles";

const NeutralLayout = props => {
  return (
    <>
      <GlobalStyle />
      <StyledWrapper id="siteWrapper" {...props}>
        <StyledHeader role="banner">
          <Container>
            <HeaderContent>
              <LogoContainer>
                <img src={config.iconLogo} alt="" />
              </LogoContainer>
            </HeaderContent>
          </Container>
        </StyledHeader>
        <StyledMain id="mainContent">
          <Container>{props.children}</Container>
        </StyledMain>
      </StyledWrapper>
    </>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${props => props.theme.greyVeryLight};
  text-align: center;
  padding: ${props => props.theme.spacingMd} 0;
`;
const StyledHeader = styled.header`
  background-color: ${props => props.theme.greyVeryLight};
  padding: ${props => props.theme.spacingMd} 0;
`;
const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LogoContainer = styled.div`
  width: 250px;
  ${({ theme }) => theme.md`
    width: 350px;
  `}
`;
const StyledMain = styled.main`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
`;

export default NeutralLayout;
